var _path, _g, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgShareLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_1006_1473",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 4,
    width: 9,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.275391 4.1268H8.33193V12.9141H0.275391V4.1268Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_1006_1473)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.8009 6.20803C7.63479 6.39399 7.41145 6.49252 7.17935 6.50682C6.96317 6.51827 6.74252 6.45551 6.56496 6.31389C6.55923 6.30816 6.16549 5.89922 5.55395 5.90208C5.16432 5.90494 4.74608 6.08662 4.47125 6.39256C4.32516 6.55546 2.41027 8.69852 2.41027 8.69852C2.14384 8.99749 2.01921 9.37765 2.04227 9.75083C2.0623 10.1211 2.22555 10.4872 2.52632 10.7531C2.82565 11.019 3.20651 11.1391 3.57755 11.1177C3.9484 11.0962 4.31497 10.9317 4.58426 10.6329L5.87474 9.18757C6.30729 9.32615 6.757 9.38337 7.20367 9.35905C7.47725 9.34331 7.7494 9.29772 8.01583 9.21904C8.00439 9.23048 5.66124 11.8553 5.66124 11.8553C5.09566 12.4872 4.32945 12.8303 3.54304 12.8761C2.75537 12.9219 1.9534 12.6674 1.32184 12.1056C0.688847 11.5422 0.344992 10.7745 0.299216 9.98811C0.25344 9.2033 0.505386 8.40259 1.07258 7.77067L3.39552 5.17021C3.95985 4.53972 4.72606 4.19801 5.51229 4.15223C6.29853 4.10789 7.10067 4.36091 7.7351 4.92416C7.96845 5.13158 8.16335 5.36887 8.32089 5.62904L7.8009 6.20803Z",
    fill: "#272525"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.66889 3.7447C4.93246 3.66746 5.20443 3.62186 5.47801 3.60755C5.92486 3.58181 6.37601 3.6376 6.80998 3.7776L8.10029 2.33227C8.36529 2.03205 8.73185 1.86897 9.10145 1.84751C9.47231 1.82605 9.85622 1.94765 10.1555 2.21354C10.4434 2.46942 10.6196 2.82543 10.641 3.21292C10.661 3.59897 10.5307 3.97483 10.273 4.26379L8.21347 6.57261C8.14624 6.64413 7.77235 7.02017 7.20945 7.05451C6.59362 7.09313 6.31306 6.79434 6.11387 6.64556C5.91342 6.49536 5.72012 6.44547 5.50233 6.45692C5.27184 6.46979 5.04833 6.57118 4.88364 6.75571L4.3667 7.33327C4.52137 7.59201 4.71324 7.83216 4.94963 8.04101C5.58119 8.6057 6.38173 8.85872 7.16939 8.81437C7.95706 8.7686 8.7247 8.42403 9.28903 7.79354L11.6105 5.19165C12.1534 4.58405 12.4399 3.81051 12.3868 2.98994C12.331 2.17921 11.9716 1.40442 11.3629 0.862438C10.7285 0.300612 9.92774 0.0475937 9.14008 0.0905085C8.35241 0.137715 7.5862 0.476563 7.02187 1.10991C7.02187 1.10991 4.6789 3.73326 4.66889 3.7447Z",
    fill: "#272525"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShareLink);
export default __webpack_public_path__ + "static/media/share_link.f39f6cdacf851b96152eaec8bfaa19a2.svg";
export { ForwardRef as ReactComponent };